
export default {
    overtimeType: state => (overtimeTypeId) => state.overtimeTypes.find(a => a.overtimeTypeId === overtimeTypeId),

    approverName : state => (id) => {
        return state.approvers.find(a => a.approverId === id)
    } ,

    employeeFiledOvertime: state => (employeeFiledOvertimeId) =>  {
        return state.employeeFiledOvertime.find(u => u.employeeFiledOvertimeId === employeeFiledOvertimeId)
    },
    getDefaultApprover: state => (val) => state.approvers.filter((a) => a.priority === val)
    

}